import { LitEntity, html, css } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';
import '../../common/bn-loading';
import '../../common/bn-surface';
import '../../common/bn-property';

class DeviceFlags extends LitEntity {
  static get styles() {
    return [sharedStyles, css`
      :host {
        flex-grow: 1;
        display: flex;
        align-items: flex-start;
        flex-wrap: wrap;
        margin-top: .25em;
      }
      .flag {
        display: inline-block;
        line-height: 1em;
        padding: 4px 10px;
        margin: 2px 2px 2px 0;
        border-radius: 100px;
        font-size: 0.75em;
      }
      .flag.dead {
        background-color: var(--red-30);
        color: white;
      }
      .flag.battery {
        background-color: var(--yellow-20);
        color: white;
      }
      .flag.sensor {
        background-color: var(--indigo-60);
        color: white;
      }
      .flag.refill-analysis {
        background-color: var(--green-30);
        color: white;
      }
      .flag.rotation-score {
        background-color: var(--black-base);
        color: white;
      }
      .flag.no-valid-levels {
        background-color: var(--orange-30);
        color: white;
      }
      .flag.snooze {
        filter: grayscale(1);
        opacity: 0.6;
      }
      .flag.snooze::before {
        content: '💤 ';
        filter: brightness(100);
      }
    `];
  }
  render() {
    if (!this.entity) {
      return html``;
    }

    const flags = [
      ...this.entity.getSubEntitiesByClass('visible'),
      ...this.entity.getSubEntitiesByClass('snooze'),
    ];

    if (flags.length === 0) {
      return html``;
    }

    return html`${flags.map(this._renderFlag)}`;
  }

  _renderFlag(flag) {
    return html`
      <div
        class="
          flag
          ${flag.properties.name}
          ${flag.properties.visibility}
        "
        title="${flag.properties.name} ${flag.properties.visibility === 'snooze' ? '(snoozed)' : ''}"
      >
        ${flag.properties.name}
      </div>`;
  }
}

window.customElements.define('device-flags', DeviceFlags);
